<div class="al-deployment-summary-compact-header {{ data.lineColor }} {{ mode }}"
     [ngStyle]="{'border-bottom':data.getBorderColorHex()}">

    <span *ngIf="fullScreen"
          class="al al-logo-color logo-block">
        <span class="path1"></span><span class="path2"></span>
    </span>

    <div class="infoblock">
        <ng-template ngFor
                     let-infoblock
                     let-infoBlockIndex="index"
                     [ngForOf]="data.infoBlocks">

            <div class="infoblock-icon">
                <i class="{{infoblock.infoBlockIconClass}}">{{infoblock.infoBlockIconMaterial}}</i>
            </div>

            <div class="infoblock-content">
                <div>
                    <div class="sub-name">
                        {{infoblock.infoBlockLabelName}}
                    </div>
                    <div>
                        <h2 class="summary-title"
                            [ngClass]="{'without-sub-name': !infoblock.infoBlockLabelName}"
                            fxLayoutAlign="start center"
                            *ngIf="infoblock.infoBlockName && infoblock.infoBlockOptions.length === 0">
                            <div class="cut-text-parent">
                                <div class="cut-text-child">{{infoblock.infoBlockName}}</div>
                            </div>
                        </h2>
                        <div class="summary-container" *ngIf="shouldDisplayDropDown(infoBlockIndex)" >
                            <p-dropdown 
                                        [scrollHeight]="'250px'"
                                        [options]="multiSelectsConfigs[infoBlockIndex].items"
                                        [(ngModel)]="multiSelectsConfigs[infoBlockIndex].selectedValue"
                                        (onChange)="handleSelected(infoBlockIndex, $event)">
                                <ng-template let-item pTemplate="selectedItem">
                                    <i class="{{item.label}}"></i>
                                    <label>{{ item.label }}</label>
                                </ng-template>
                                <ng-template let-item
                                             pTemplate="item">
                                             <div class="item-container">
                                                <i class="{{item.icon}}"></i>
                                                <label class="item-label">{{ item.label }}</label>
                                             </div>
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <div class="blocks">
        <ng-template ngFor
                     let-block
                     [ngForOf]="data.summaryBlocks">
            <div class="block">
                <div class="quantity"
                     fxFlex>
                    {{block.quantity | alPrefixMultiplier}}
                </div>
                <div class="icon-label">
                    <i class="{{block.iconClass}}">{{block.iconMaterial}}</i>
                    <p>{{block.label}}</p>
                </div>
            </div>
        </ng-template>
    </div>
</div>